import dotenv from 'dotenv-flow';

import isJestRunning from './isJestRunning';

const STRING_BASE = [
  'REACT_APP_AUTH0_CLIENT_ID',
  'REACT_APP_AUTH0_DOMAIN',
  'REACT_APP_GRAPHQL_URL',
  'REACT_APP_HUBSPOT_ACCOUNT',
  'REACT_APP_PUBLIC_URL',
  'REACT_APP_PAYMENT_PUBLIC_GRAPHQL_URL',
  'REACT_APP_QUESTION_TRACKING_URL',
  'REACT_APP_SENTRY_DSN',
  'REACT_APP_STAGE',
  'REACT_APP_STRIPE_CA_PUBLISHABLE_KEY',
  'REACT_APP_STRIPE_US_PUBLISHABLE_KEY',
  'REACT_APP_VERSION_CONTROLLER_GRAPHQL_URL',
  'REACT_APP_API_MAX_RETRIES',
  'REACT_APP_API_BASE_DELAY',
  'REACT_APP_API_MAX_DELAY',
  'REACT_APP_AUTH_SERVICE_URL',
  'REACT_APP_ADMIN_FRONTEND_URL'
] as const;

type Keys = typeof STRING_BASE[number];

export type Env = { [index in Keys]: string };

if (isJestRunning()) {
  // can't figure out how to use .jest.config.js since it's managed by react-scripts, so the workaround
  // for globalSetup is to instead setup .env here

  // inject enviornment variables with dotenv-flow (which takes care of .env*.local), since Jest isn't handling it
  dotenv.config({ node_env: 'development', silent: true });
}

// runtime check during bootstrap
STRING_BASE.forEach((key) => {
  const val = process.env[key];

  if (!val) {
    throw new Error(`Environment variable isn't defined, ${key}`);
  }
});

export default function (): Env {
  const env: Record<string, string> = {};
  STRING_BASE.forEach((key) => {
    env[key] = process.env[key] as string;
  });
  return env as Env;
}
